/**
 * 같은 쓰기 요청(메서드·주소·토큰·본문이 같음)이 아직 진행 중이면 새로 보내지 않고 그 결과를 같이 받는다.
 * 버튼 연타·Enter 연속 입력으로 같은 처리가 두 번 서버에 가는 걸 막는 마지막 안전망 — 화면 버튼의 처리 중 비활성은 따로 둔다.
 */
const inFlight = new Map<string, Promise<unknown>>();

export function dedupeWrite<T>(key: string | null, run: () => Promise<T>): Promise<T> {
  if (key == null) return run();
  const running = inFlight.get(key);
  if (running) return running as Promise<T>;
  const promise = run().finally(() => inFlight.delete(key));
  inFlight.set(key, promise);
  return promise;
}

/** GET·HEAD 는 묶지 않는다. 본문이 문자열·없음·FormData 가 아니면(스트림 등) 비교할 수 없어 묶지 않는다 */
export function writeKey(
  method: string | undefined,
  url: string,
  token: string | undefined,
  body: BodyInit | null | undefined,
): string | null {
  const m = (method ?? 'GET').toUpperCase();
  if (m === 'GET' || m === 'HEAD') return null;
  const bodyKey = bodyIdentity(body);
  if (bodyKey == null) return null;
  return `${m} ${url} ${token ?? ''} ${bodyKey}`;
}

function bodyIdentity(body: BodyInit | null | undefined): string | null {
  if (body == null) return '';
  if (typeof body === 'string') return body;
  if (typeof FormData !== 'undefined' && body instanceof FormData) {
    const parts: string[] = [];
    body.forEach((value, name) => {
      parts.push(
        typeof value === 'string'
          ? `${name}=${value}`
          : `${name}=file:${value.name}:${value.size}:${value.type}:${value.lastModified}`,
      );
    });
    return parts.join('&');
  }
  return null;
}
